import { Yup } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import {
  constants,
} from 'cng-web-lib'

const {
  locale: {
    key: {
      CommonValidationMessageKeys,
    },
  },
} = constants

function makeValidationSchema(translate) {
  let requiredMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.REQUIRED
  )
  let dateTypeErrorMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.DATE_TYPE_ERROR
  )

  return Yup.object({
    platform: Yup.string().required(requiredMessage).nullable(),
    type: Yup.string().required(requiredMessage).nullable(),
    calistaCode: Yup.string(),
    ediCode: Yup.string(),
    codeDesc: Yup.string().required(requiredMessage).nullable(),
  })
}

export default makeValidationSchema
